import React from 'react';
import { Link } from 'react-router-dom';

/**
 * AssessmentHeader
 *
 * Props:
 * - type: 'self-guided' | other string, used to render the title
 * - setShowGuidanceModal: function to control guidance modal visibility
 * - setUserHasChosen: function to mark that the user has chosen a path
 */
const AssessmentHeader = ({ type, setShowGuidanceModal, setUserHasChosen }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6 mb-8">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          {type === 'self-guided' ? 'Self-Guided' : 'Professional'} Energy Assessment
        </h1>

        <div className="flex items-center gap-4">
          {/* Consultant Guidance Button */}
          <button
            onClick={() => {
              setShowGuidanceModal(true);
              setUserHasChosen(false);
            }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg 
                   bg-gradient-to-r from-emerald-600 to-emerald-700 
                   text-white font-medium shadow-sm hover:shadow-md 
                   transition-all duration-200 hover:from-emerald-700 hover:to-emerald-800 
                   focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-4 h-4 text-white"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Consultant Guidance
          </button>

          {/* Back to Home */}
          <Link
            to="/"
            className="text-emerald-700 dark:text-emerald-400 hover:text-emerald-800 
                   dark:hover:text-emerald-300 transition-colors font-medium"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AssessmentHeader;


